// Dependecies
//
var $ = require('jquery');


// Localisation
//
var cookiesUtils = require('cookies-utils');
var localcookie = cookiesUtils.read('localecookie');

if (localcookie == "fr" || localcookie == "fr-ca") {
    require('imports-loader?define=>false&jQuery=jquery!jquery-validation/dist/localization/messages_fr.js');
}


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/forms-validation/localization.js
 ** module id = 51
 ** module chunks = 0 1
 **/